export interface IItemParams {
    color: string; // np. #ff0000, red, rgb(255,0,0)
    url: string;   // np. link, Base64
    text: string;
    callback: () => void;
    isSelected: boolean;
}

export class ItemParams implements IItemParams {
    constructor(
        public color: string,
        public url: string,
        public text: string,
        private _callback: (self: IItemParams) => void,
        public isSelected: boolean = false,
    ) { }

    public callback() { this._callback(this); }
}